import { Fragment, jsx, jsxs } from "react/jsx-runtime";
import { Form, Input, Button } from "antd";
import { UserOutlined, LockOutlined } from "@ant-design/icons";
import { md5 } from "js-md5";
import { getT } from "../../../../../_utils/intl";
import { LoginType } from "../../../types";
import useStyles from "../../../style";
const AccountLogin = ({
  onLogin,
  goForgotPassword,
  showForgotPassword
}) => {
  const t = getT();
  const { styles } = useStyles();
  return /* @__PURE__ */ jsxs(Fragment, { children: [
    /* @__PURE__ */ jsxs(
      Form,
      {
        size: "large",
        onFinish: async (v) => {
          var _a, _b;
          onLogin({
            account: (_a = v.account) == null ? void 0 : _a.trim(),
            password: md5((_b = v.password) == null ? void 0 : _b.trim()),
            loginType: LoginType.Account
          });
        },
        children: [
          /* @__PURE__ */ jsx(
            Form.Item,
            {
              name: "account",
              rules: [{
                required: true,
                message: t("login.input.required")
              }],
              children: /* @__PURE__ */ jsx(Input, { prefix: /* @__PURE__ */ jsx(UserOutlined, {}) })
            }
          ),
          /* @__PURE__ */ jsx(
            Form.Item,
            {
              name: "password",
              rules: [{
                required: true,
                message: t("login.input.required")
              }],
              children: /* @__PURE__ */ jsx(Input.Password, { prefix: /* @__PURE__ */ jsx(LockOutlined, {}) })
            }
          ),
          /* @__PURE__ */ jsx(Form.Item, { children: /* @__PURE__ */ jsx(Button, { htmlType: "submit", size: "large", type: "primary", style: { width: "100%" }, children: t("login.btn.login") }) })
        ]
      }
    ),
    showForgotPassword ? /* @__PURE__ */ jsx("div", { className: styles.forgotPassword, children: /* @__PURE__ */ jsx("a", { onClick: goForgotPassword, children: t("login.btn.forgot_password") }) }) : null
  ] });
};
var AccountLogin_default = AccountLogin;
export {
  AccountLogin_default as default
};
